export enum TaskType {
    addAsset = 'addAsset',
    analyze = 'analyze',
    biometry = 'biometry',
    diagnose = 'diagnose',
    grade = 'grade',
    request = 'request',
    supervise = 'supervise',
}

export enum TaskStatus {
    accepted = 'accepted',
    cancelled = 'cancelled',
    closed = 'closed',
    open = 'open',
}

export enum TaskTransition {
    accept = 'accept',
    assignToPractitioner = 'assignToPractitioner',
    cancel = 'cancel',
    perform = 'perform',
}
